// auto-generated by gen-langs-map.cjs – DO NOT EDIT
import { StreamLanguage } from '@codemirror/language';
import { cpp as _cpp } from '@codemirror/lang-cpp';
import { css as _css } from '@codemirror/lang-css';
import { go as _go } from '@codemirror/lang-go';
import { html as _html } from '@codemirror/lang-html';
import { java as _java } from '@codemirror/lang-java';
import { javascript } from '@codemirror/lang-javascript';
import { jinja as _jinja } from '@codemirror/lang-jinja';
import { json as _json } from '@codemirror/lang-json';
import { less as _less } from '@codemirror/lang-less';
import { liquid as _liquid } from '@codemirror/lang-liquid';
import { markdown as _markdown } from '@codemirror/lang-markdown';
import { php as _php } from '@codemirror/lang-php';
import { python } from '@codemirror/lang-python';
import { rust } from '@codemirror/lang-rust';
import { sass as _sass } from '@codemirror/lang-sass';
import { wast as _wast } from '@codemirror/lang-wast';
import { xml as _xml } from '@codemirror/lang-xml';
import { yaml as _yaml } from '@codemirror/lang-yaml';
import { apl as _apl } from '@codemirror/legacy-modes/mode/apl';
import { asciiArmor } from '@codemirror/legacy-modes/mode/asciiarmor';
import { asn1 as _asn } from '@codemirror/legacy-modes/mode/asn1';
import { brainfuck } from '@codemirror/legacy-modes/mode/brainfuck';
import { cobol } from '@codemirror/legacy-modes/mode/cobol';
import { csharp, dart as _dart, kotlin, objectiveCpp, scala as _scala, squirrel } from '@codemirror/legacy-modes/mode/clike';
import { clojure } from '@codemirror/legacy-modes/mode/clojure';
import { gss as _gss } from '@codemirror/legacy-modes/mode/css';
import { cmake as _cmake } from '@codemirror/legacy-modes/mode/cmake';
import { coffeeScript } from '@codemirror/legacy-modes/mode/coffeescript';
import { commonLisp } from '@codemirror/legacy-modes/mode/commonlisp';
import { cypher as _cypher } from '@codemirror/legacy-modes/mode/cypher';
import { cython } from '@codemirror/legacy-modes/mode/python';
import { crystal } from '@codemirror/legacy-modes/mode/crystal';
import { d as _d } from '@codemirror/legacy-modes/mode/d';
import { diff as _diff } from '@codemirror/legacy-modes/mode/diff';
import { dtd as _dtd } from '@codemirror/legacy-modes/mode/dtd';
import { dylan as _dylan } from '@codemirror/legacy-modes/mode/dylan';
import { ecl as _ecl } from '@codemirror/legacy-modes/mode/ecl';
import { eiffel } from '@codemirror/legacy-modes/mode/eiffel';
import { elm as _elm } from '@codemirror/legacy-modes/mode/elm';
import { erlang } from '@codemirror/legacy-modes/mode/erlang';
import { factor as _factor } from '@codemirror/legacy-modes/mode/factor';
import { forth as _forth } from '@codemirror/legacy-modes/mode/forth';
import { fortran } from '@codemirror/legacy-modes/mode/fortran';
import { fSharp, oCaml, sml as _sml } from '@codemirror/legacy-modes/mode/mllike';
import { gas } from '@codemirror/legacy-modes/mode/gas';
import { gherkin } from '@codemirror/legacy-modes/mode/gherkin';
import { groovy as _groovy } from '@codemirror/legacy-modes/mode/groovy';
import { haskell } from '@codemirror/legacy-modes/mode/haskell';
import { haxe, hxml as _hxml } from '@codemirror/legacy-modes/mode/haxe';
import { idl } from '@codemirror/legacy-modes/mode/idl';
import { jsonld as _jsonld } from '@codemirror/legacy-modes/mode/javascript';
import { julia } from '@codemirror/legacy-modes/mode/julia';
import { liveScript } from '@codemirror/legacy-modes/mode/livescript';
import { lua as _lua } from '@codemirror/legacy-modes/mode/lua';
import { mirc } from '@codemirror/legacy-modes/mode/mirc';
import { mathematica } from '@codemirror/legacy-modes/mode/mathematica';
import { modelica } from '@codemirror/legacy-modes/mode/modelica';
import { mumps } from '@codemirror/legacy-modes/mode/mumps';
import { mbox as _mbox } from '@codemirror/legacy-modes/mode/mbox';
import { nsis } from '@codemirror/legacy-modes/mode/nsis';
import { ntriples } from '@codemirror/legacy-modes/mode/ntriples';
import { octave } from '@codemirror/legacy-modes/mode/octave';
import { oz as _oz } from '@codemirror/legacy-modes/mode/oz';
import { pascal } from '@codemirror/legacy-modes/mode/pascal';
import { perl } from '@codemirror/legacy-modes/mode/perl';
import { pig as _pig } from '@codemirror/legacy-modes/mode/pig';
import { powerShell } from '@codemirror/legacy-modes/mode/powershell';
import { properties as _properties } from '@codemirror/legacy-modes/mode/properties';
import { protobuf } from '@codemirror/legacy-modes/mode/protobuf';
import { pug as _pug } from '@codemirror/legacy-modes/mode/pug';
import { puppet } from '@codemirror/legacy-modes/mode/puppet';
import { q as _q } from '@codemirror/legacy-modes/mode/q';
import { r as _r } from '@codemirror/legacy-modes/mode/r';
import { rpmSpec } from '@codemirror/legacy-modes/mode/rpm';
import { ruby } from '@codemirror/legacy-modes/mode/ruby';
import { sas as _sas } from '@codemirror/legacy-modes/mode/sas';
import { scheme } from '@codemirror/legacy-modes/mode/scheme';
import { shell } from '@codemirror/legacy-modes/mode/shell';
import { sieve as _sieve } from '@codemirror/legacy-modes/mode/sieve';
import { smalltalk } from '@codemirror/legacy-modes/mode/smalltalk';
import { sparql as _sparql } from '@codemirror/legacy-modes/mode/sparql';
import { stylus } from '@codemirror/legacy-modes/mode/stylus';
import { swift as _swift } from '@codemirror/legacy-modes/mode/swift';
import { stex } from '@codemirror/legacy-modes/mode/stex';
import { verilog } from '@codemirror/legacy-modes/mode/verilog';
import { tcl as _tcl } from '@codemirror/legacy-modes/mode/tcl';
import { textile as _textile } from '@codemirror/legacy-modes/mode/textile';
import { toml as _toml } from '@codemirror/legacy-modes/mode/toml';
import { troff } from '@codemirror/legacy-modes/mode/troff';
import { ttcn as _ttcn } from '@codemirror/legacy-modes/mode/ttcn';
import { ttcnCfg } from '@codemirror/legacy-modes/mode/ttcn-cfg';
import { turtle } from '@codemirror/legacy-modes/mode/turtle';
import { webIDL } from '@codemirror/legacy-modes/mode/webidl';
import { vb as _vb } from '@codemirror/legacy-modes/mode/vb';
import { vbScript } from '@codemirror/legacy-modes/mode/vbscript';
import { velocity } from '@codemirror/legacy-modes/mode/velocity';
import { vhdl as _vhdl } from '@codemirror/legacy-modes/mode/vhdl';
import { xQuery } from '@codemirror/legacy-modes/mode/xquery';
import { yacas } from '@codemirror/legacy-modes/mode/yacas';
import { z80 as _z } from '@codemirror/legacy-modes/mode/z80';
import { mscgen as _mscgen, msgenny as _msgenny, xu as _xu } from '@codemirror/legacy-modes/mode/mscgen';
import { vue as _vue } from '@codemirror/lang-vue';
import * as SQL from '@codemirror/lang-sql';
import { nix as _nix } from '@replit/codemirror-lang-nix';
import { svelte as _svelte } from '@replit/codemirror-lang-svelte';
import { solidity as _solidity } from '@replit/codemirror-lang-solidity';
export var langs = {
  "1": () => StreamLanguage.define(troff),
  "2": () => StreamLanguage.define(troff),
  "3": () => StreamLanguage.define(troff),
  "4": () => StreamLanguage.define(troff),
  "4th": () => StreamLanguage.define(_forth),
  "5": () => StreamLanguage.define(troff),
  "6": () => StreamLanguage.define(troff),
  "7": () => StreamLanguage.define(troff),
  "8": () => StreamLanguage.define(troff),
  "9": () => StreamLanguage.define(troff),
  "apl": () => StreamLanguage.define(_apl),
  "asc": () => StreamLanguage.define(asciiArmor),
  "asn": () => StreamLanguage.define(_asn({})),
  "asn1": () => StreamLanguage.define(_asn({})),
  "b": () => StreamLanguage.define(brainfuck),
  "bash": () => StreamLanguage.define(shell),
  "bf": () => StreamLanguage.define(brainfuck),
  "BUILD": () => python(),
  "bzl": () => python(),
  "c": () => _cpp(),
  "c++": () => _cpp(),
  "cc": () => _cpp(),
  "cfg": () => StreamLanguage.define(ttcnCfg),
  "cjs": () => javascript(),
  "cl": () => StreamLanguage.define(commonLisp),
  "clj": () => StreamLanguage.define(clojure),
  "cljc": () => StreamLanguage.define(clojure),
  "cljs": () => StreamLanguage.define(clojure),
  "cljx": () => StreamLanguage.define(clojure),
  "cmake": () => StreamLanguage.define(_cmake),
  "cmake.in": () => StreamLanguage.define(_cmake),
  "cob": () => StreamLanguage.define(cobol),
  "coffee": () => StreamLanguage.define(coffeeScript),
  "cpp": () => _cpp(),
  "cpy": () => StreamLanguage.define(cobol),
  "cql": () => SQL.sql({
    dialect: SQL.Cassandra
  }),
  "cr": () => StreamLanguage.define(crystal),
  "cs": () => StreamLanguage.define(csharp),
  "css": () => _css(),
  "cts": () => javascript({
    typescript: true
  }),
  "cxx": () => _cpp(),
  "cyp": () => StreamLanguage.define(_cypher),
  "cypher": () => StreamLanguage.define(_cypher),
  "d": () => StreamLanguage.define(_d),
  "dart": () => StreamLanguage.define(_dart),
  "diff": () => StreamLanguage.define(_diff),
  "dtd": () => StreamLanguage.define(_dtd),
  "dyalog": () => StreamLanguage.define(_apl),
  "dyl": () => StreamLanguage.define(_dylan),
  "dylan": () => StreamLanguage.define(_dylan),
  "e": () => StreamLanguage.define(eiffel),
  "ecl": () => StreamLanguage.define(_ecl),
  "edn": () => StreamLanguage.define(clojure),
  "el": () => StreamLanguage.define(commonLisp),
  "elm": () => StreamLanguage.define(_elm),
  "erl": () => StreamLanguage.define(erlang),
  "f": () => StreamLanguage.define(fortran),
  "f77": () => StreamLanguage.define(fortran),
  "f90": () => StreamLanguage.define(fortran),
  "f95": () => StreamLanguage.define(fortran),
  "factor": () => StreamLanguage.define(_factor),
  "feature": () => StreamLanguage.define(gherkin),
  "for": () => StreamLanguage.define(fortran),
  "forth": () => StreamLanguage.define(_forth),
  "fs": () => StreamLanguage.define(fSharp),
  "fth": () => StreamLanguage.define(_forth),
  "fun": () => StreamLanguage.define(_sml),
  "go": () => _go(),
  "gradle": () => StreamLanguage.define(_groovy),
  "groovy": () => StreamLanguage.define(_groovy),
  "gss": () => StreamLanguage.define(_gss),
  "h": () => _cpp(),
  "h++": () => _cpp(),
  "handlebars": () => _html(),
  "hbs": () => _html(),
  "hh": () => _cpp(),
  "hpp": () => _cpp(),
  "hs": () => StreamLanguage.define(haskell),
  "htm": () => _html(),
  "html": () => _html(),
  "hx": () => StreamLanguage.define(haxe),
  "hxml": () => StreamLanguage.define(_hxml),
  "hxx": () => _cpp(),
  "in": () => StreamLanguage.define(_properties),
  "ini": () => StreamLanguage.define(_properties),
  "ino": () => _cpp(),
  "intr": () => StreamLanguage.define(_dylan),
  "j2": () => _jinja(),
  "jade": () => StreamLanguage.define(_pug),
  "java": () => _java(),
  "jinja": () => _jinja(),
  "jinja2": () => _jinja(),
  "jl": () => StreamLanguage.define(julia),
  "js": () => javascript(),
  "json": () => _json(),
  "jsonld": () => StreamLanguage.define(_jsonld),
  "jsx": () => javascript({
    jsx: true
  }),
  "ksh": () => StreamLanguage.define(shell),
  "kt": () => StreamLanguage.define(kotlin),
  "kts": () => StreamLanguage.define(kotlin),
  "less": () => _less(),
  "liquid": () => _liquid(),
  "lisp": () => StreamLanguage.define(commonLisp),
  "ls": () => StreamLanguage.define(liveScript),
  "ltx": () => StreamLanguage.define(stex),
  "lua": () => StreamLanguage.define(_lua),
  "m": () => StreamLanguage.define(octave),
  "map": () => _json(),
  "markdown": () => _markdown(),
  "mbox": () => StreamLanguage.define(_mbox),
  "md": () => _markdown(),
  "mjs": () => javascript(),
  "mkd": () => _markdown(),
  "ml": () => StreamLanguage.define(oCaml),
  "mli": () => StreamLanguage.define(oCaml),
  "mll": () => StreamLanguage.define(oCaml),
  "mly": () => StreamLanguage.define(oCaml),
  "mm": () => StreamLanguage.define(objectiveCpp),
  "mo": () => StreamLanguage.define(modelica),
  "mps": () => StreamLanguage.define(mumps),
  "mrc": () => StreamLanguage.define(mirc),
  "msc": () => StreamLanguage.define(_mscgen),
  "mscgen": () => StreamLanguage.define(_mscgen),
  "mscin": () => StreamLanguage.define(_mscgen),
  "msgenny": () => StreamLanguage.define(_msgenny),
  "mts": () => javascript({
    typescript: true
  }),
  "nb": () => StreamLanguage.define(mathematica),
  "nix": () => _nix(),
  "nq": () => StreamLanguage.define(ntriples),
  "nsh": () => StreamLanguage.define(nsis),
  "nsi": () => StreamLanguage.define(nsis),
  "nt": () => StreamLanguage.define(ntriples),
  "nut": () => StreamLanguage.define(squirrel),
  "oz": () => StreamLanguage.define(_oz),
  "p": () => StreamLanguage.define(pascal),
  "pas": () => StreamLanguage.define(pascal),
  "patch": () => StreamLanguage.define(_diff),
  "pgp": () => StreamLanguage.define(asciiArmor),
  "php": () => _php(),
  "php3": () => _php(),
  "php4": () => _php(),
  "php5": () => _php(),
  "php7": () => _php(),
  "phtml": () => _php(),
  "pig": () => StreamLanguage.define(_pig),
  "pl": () => StreamLanguage.define(perl),
  "pls": () => SQL.sql({
    dialect: SQL.PLSQL
  }),
  "pm": () => StreamLanguage.define(perl),
  "pp": () => StreamLanguage.define(puppet),
  "pro": () => StreamLanguage.define(idl),
  "properties": () => StreamLanguage.define(_properties),
  "proto": () => StreamLanguage.define(protobuf),
  "ps1": () => StreamLanguage.define(powerShell),
  "psd1": () => StreamLanguage.define(powerShell),
  "psm1": () => StreamLanguage.define(powerShell),
  "pug": () => StreamLanguage.define(_pug),
  "pxd": () => StreamLanguage.define(cython),
  "pxi": () => StreamLanguage.define(cython),
  "py": () => python(),
  "pyw": () => python(),
  "pyx": () => StreamLanguage.define(cython),
  "q": () => StreamLanguage.define(_q),
  "r": () => StreamLanguage.define(_r),
  "R": () => StreamLanguage.define(_r),
  "rb": () => StreamLanguage.define(ruby),
  "rq": () => StreamLanguage.define(_sparql),
  "rs": () => rust(),
  "s": () => StreamLanguage.define(gas),
  "sas": () => StreamLanguage.define(_sas),
  "sass": () => _sass({
    indented: true
  }),
  "scala": () => StreamLanguage.define(_scala),
  "scm": () => StreamLanguage.define(scheme),
  "scss": () => _sass(),
  "sh": () => StreamLanguage.define(shell),
  "sieve": () => StreamLanguage.define(_sieve),
  "sig": () => StreamLanguage.define(_sml),
  "siv": () => StreamLanguage.define(_sieve),
  "smackspec": () => StreamLanguage.define(_sml),
  "sml": () => StreamLanguage.define(_sml),
  "solidity": () => _solidity,
  "sparql": () => StreamLanguage.define(_sparql),
  "spec": () => StreamLanguage.define(rpmSpec),
  "sql": () => SQL.sql({
    dialect: SQL.StandardSQL
  }),
  "ss": () => StreamLanguage.define(scheme),
  "st": () => StreamLanguage.define(smalltalk),
  "styl": () => StreamLanguage.define(stylus),
  "sv": () => StreamLanguage.define(verilog),
  "svelte": () => _svelte(),
  "svg": () => _xml(),
  "svh": () => StreamLanguage.define(verilog),
  "swift": () => StreamLanguage.define(_swift),
  "tcl": () => StreamLanguage.define(_tcl),
  "tex": () => StreamLanguage.define(stex),
  "text": () => StreamLanguage.define(stex),
  "textile": () => StreamLanguage.define(_textile),
  "toml": () => StreamLanguage.define(_toml),
  "ts": () => javascript({
    typescript: true
  }),
  "tsx": () => javascript({
    jsx: true,
    typescript: true
  }),
  "ttcn": () => StreamLanguage.define(_ttcn),
  "ttcn3": () => StreamLanguage.define(_ttcn),
  "ttcnpp": () => StreamLanguage.define(_ttcn),
  "ttl": () => StreamLanguage.define(turtle),
  "v": () => StreamLanguage.define(verilog),
  "vb": () => StreamLanguage.define(_vb),
  "vbs": () => StreamLanguage.define(vbScript),
  "vhd": () => StreamLanguage.define(_vhdl),
  "vhdl": () => StreamLanguage.define(_vhdl),
  "vtl": () => StreamLanguage.define(velocity),
  "vue": () => _vue(),
  "wast": () => _wast(),
  "wat": () => _wast(),
  "webidl": () => StreamLanguage.define(webIDL),
  "wl": () => StreamLanguage.define(mathematica),
  "wls": () => StreamLanguage.define(mathematica),
  "xml": () => _xml(),
  "xq": () => StreamLanguage.define(xQuery),
  "xqm": () => StreamLanguage.define(xQuery),
  "xquery": () => StreamLanguage.define(xQuery),
  "xqy": () => StreamLanguage.define(xQuery),
  "xsd": () => _xml(),
  "xsl": () => _xml(),
  "xu": () => StreamLanguage.define(_xu),
  "xy": () => StreamLanguage.define(xQuery),
  "yaml": () => _yaml(),
  "yml": () => _yaml(),
  "ys": () => StreamLanguage.define(yacas),
  "z80": () => StreamLanguage.define(_z)
};
export var langNames = Object.keys(langs);
export function loadLanguage(name) {
  return langs[name] ? langs[name]() : null;
}